module.exports = __webpack_public_path__ + "assets/img/2022_04.b02fdd38.png";